import { Form, Input, Modal, Select, Switch, Typography } from "antd";
import { useEffect } from "react";

const { Text } = Typography;

function LinhaSwitch({ nome, titulo, ajuda }) {
  return (
    <div style={{ display: "flex", gap: 12, alignItems: "flex-start" }}>
      <Form.Item name={nome} valuePropName="checked" noStyle>
        <Switch style={{ marginTop: 1 }} />
      </Form.Item>
      <div>
        <Text strong>{titulo}</Text>
        <div>
          <Text type="secondary" style={{ fontSize: 12 }}>
            {ajuda}
          </Text>
        </div>
      </div>
    </div>
  );
}

const opcoes = (itens) =>
  (itens || []).map((item) => ({ value: item.id, label: item.descricao }));

export default function CameraFormModal({
  aberto,
  camera,
  zonasDaFilial,
  linhasDaFilial,
  salvando,
  onSalvar,
  onFechar,
}) {
  const [form] = Form.useForm();

  useEffect(() => {
    if (!aberto) return;
    form.setFieldsValue(
      camera
        ? {
            nome: camera.nome,
            endereco: camera.endereco,
            ativa: camera.ativa,
            reencode: camera.reencode,
            zonas: camera.zonas || [],
            linhas: camera.linhas || [],
          }
        : {
            nome: "",
            endereco: "",
            ativa: true,
            reencode: true,
            zonas: [],
            linhas: [],
          }
    );
  }, [aberto, camera, form]);

  return (
    <Modal
      open={aberto}
      title={camera ? "Editar câmera" : "Adicionar câmera"}
      okText="Salvar"
      cancelText="Cancelar"
      confirmLoading={salvando}
      destroyOnClose
      onCancel={onFechar}
      onOk={() => form.validateFields().then(onSalvar)}>
      <Form form={form} layout="vertical" requiredMark={false}>
        <Form.Item
          name="nome"
          label="Nome"
          rules={[{ required: true, message: "Informe o nome da câmera." }]}>
          <Input placeholder="Ex.: Caixa" maxLength={80} />
        </Form.Item>
        <Form.Item
          name="endereco"
          label="Endereço"
          extra="Câmera na rede da loja: rtsp://usuario:senha@IP:porta/caminho. DVR que envia para o gateway: rtmp://gateway/dvr/nome."
          rules={[
            { required: true, message: "Informe o endereço da câmera." },
          ]}>
          <Input
            placeholder="rtsp://usuario:senha@192.168.0.10:554/..."
            maxLength={300}
          />
        </Form.Item>
        <Form.Item
          name="zonas"
          label="Zonas"
          extra="Zonas da filial que esta câmera enxerga. A inferência conta as pessoas nelas.">
          <Select
            mode="multiple"
            allowClear
            placeholder="Nenhuma zona"
            options={opcoes(zonasDaFilial)}
            optionFilterProp="label"
          />
        </Form.Item>
        <Form.Item
          name="linhas"
          label="Linhas"
          extra="Linhas de passagem da filial que esta câmera enxerga.">
          <Select
            mode="multiple"
            allowClear
            placeholder="Nenhuma linha"
            options={opcoes(linhasDaFilial)}
            optionFilterProp="label"
          />
        </Form.Item>
        <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
          <LinhaSwitch
            nome="ativa"
            titulo="Ativa"
            ajuda="Desativada, o gateway desconecta a câmera e não grava."
          />
          <LinhaSwitch
            nome="reencode"
            titulo="Re-encode no gateway"
            ajuda="Deixa o vídeo em 960×576 a 3 fps. Desligue só se o substream da câmera já vem nesse formato."
          />
        </div>
      </Form>
    </Modal>
  );
}
